import { errorWrapper } from 'utility/error';

import { apiClient } from './api';
import { toActionDomain } from './transformers/toActionDomain';

// Fetches all improvement actions for a tenant and maps them onto the `Data.Action` domain.
async function getActions(args: { tenantId: string }) {
  const { tenantId } = args;

  const apiCall = apiClient.Action_GetActions({
    params: { tenantId },
  });

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to load actions',
    },
    onSuccess: (dtos) => {
      const { actionDomain } = toActionDomain({ dtos: dtos ?? [] });
      return { actionDomain };
    },
  });
}

export { getActions };
